import React, { useEffect, useRef } from "react";
import tbmPlannerImg from "../../assets/online/TBM-Planner-1.png";

export default function LandingOnlineWorkoutPlanner() {
  const containerRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        } 
      });
    };


    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);
  return (
    <div
      id="workout-planner"
      className="online__workout-planner position-relative bg-primary text-white"
    >
      <div ref={containerRef} className="opacity-0">

      <h2 className="workout-planner__title online-title mb-1">
        Workout Planner
      </h2>
      <p className="workout-planner__desc ">
        {" "}
        Mide tu progreso, alcanza tus metas y gana beneficios.
      </p>

      <img alt="tbm workout planner desktop" className="workout-planner__image" src={tbmPlannerImg}/>
      </div>

    </div>
  );
}
